// Posible pagination method https://github.com/wp-graphql/wp-graphql/issues/430, https://www.howtographql.com/vue-apollo/9-pagination/

import axios from 'axios'
import _debounce from 'lodash/debounce'
import _get from 'lodash/get'
import _find from 'lodash/find'
import _merge from 'lodash/merge'
import _forEach from 'lodash/forEach'
import _map from 'lodash/map'
import _isEmpty from 'lodash/isEmpty'
import _concat from 'lodash/concat'
import _isArray from 'lodash/isArray'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue' // https://github.com/greyby/vue-spinner
import moment from 'moment'
import 'moment/locale/da'
import vselect from 'vue-select' // https://sagalbot.github.io/vue-select/docs/
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  name: 'Search',

  data: function() {
    return {
      searchUrl: 'https://fh.ankiro.dk/Rest/lo-ftf.wp.stage.ng.peytz.dk/',
      searchUrlDemo: 'http://demo1.suite.ankiro.dk/Rest/fho.dk/',
      searchUrlStage: 'https://fh.ankiro.dk/Rest/lo-ftf.wp.stage.ng.peytz.dk/',
      searchUrlProd: 'https://fh.ankiro.dk/Rest/fho.dk/',
      search: '',
      searchQuery: {},
      searchId: null,
      searchResponse: {},
      documentOffset: 0,
      documents: {},
      SearchString: '',
      TotalResults: 0,
      searchId: null,
      banner: false,
      loading: false,
      cancelSource: null,
      paginationCount: 15,
      paged: 0,
    }
  },

  components: {
    'loader': PulseLoader,
    vselect,
    Autocomplete
  },

  // http://usefulangle.com/post/78/javascript-get-url-parameters
  // http://usefulangle.com/post/81/javascript-change-url-parameters
  created: function() {
    let that = this

    // Set search url
    this.setSearchUrl()
    // Grab query params and set filters
    this.handleQueryParams()

    this.cancelSearch()
    this.searchPosts()
  },

  methods: {
    watcherSearch: _debounce(function(newSearch, oldSearch) {
        this.run();

        this.updateURL('s', this.search)
      },
      500
    ),

    setSearchUrl() {
      let location = String(window.location.hostname).replace(/^www\./,'')

      if ( location == 'fho.dk' ) {
        this.searchUrl = this.searchUrlProd
      } else {
        this.searchUrl = this.searchUrlStage
      }
    },

    doSearch() {
      this.run();

      this.updateURL('s', this.search)
    },

    run: function() {
      this.loading = true
      this.cancelSearch()
      this.updatePaged( 0 )
      this.searchPosts()
    },

    prevPage: function() {
      if ( this.searchResponse.data.Decorations.Pagination.CurrentPage > 0 ) {
        let paged = this.searchResponse.data.Decorations.Pagination.CurrentPage - 1
        this.updatePaged(paged)
      }

      this.scrollToTop()
      this.searchPosts()
    },

    nextPage: function() {
      if ( this.searchResponse.data.Decorations.Pagination.CurrentPage < this.searchResponse.data.Decorations.Pagination.TotalPages ) {
        let paged = ( this.searchResponse.data.Decorations.Pagination.CurrentPage == 0 ) ? 1 : this.searchResponse.data.Decorations.Pagination.CurrentPage + 1
        this.updatePaged(paged)
      }

      this.scrollToTop()
      this.searchPosts()
    },

    scrollToTop: function() {
      this.$scrollTo('#search-form', 500, { offset: 100 });
    },

    updatePaged: function( paged ) {
      this.paged = paged

      if ( typeof paged == 'undefined' || paged == null || paged == null || paged == 0 ) {
        this.updateURL('pagination', '', false, true)
      } else {
        this.updateURL('pagination', paged)
      }
    },

    // Handle incoming URL params
    handleQueryParams: function() {
      let url          = new URL(window.location)
      let searchParams = new URLSearchParams(url.search)

      // Search param
      let search  = searchParams.get('s')
      this.search = search // OBS! code injection
      let paged   = searchParams.get('pagination')
      this.updatePaged(paged)

    },

    // Update URL params
    updateURL: function(param, val, append = false, remove = false) {
      let url          = new URL(window.location)
      let searchParams = new URLSearchParams(url.search)

      if (val == '' && remove) {
        searchParams.delete(param)
      } else if (searchParams.has(param) && append) {
        _forEach(searchParams.entries(), (pair) => {
        let paramValue = pair[1]

        if (paramValue != val) {
          searchParams.append(param, val)
        }
        })
      } else if (Array.isArray(val)) {
        searchParams.delete(param)
        _forEach(val, (array_val) => {
        searchParams.append(param, array_val)
        })
      } else {
        searchParams.set(param, val)
      }

      url.search = searchParams.toString()
      history.pushState(null, null, url.toString())
    },

    getSearchParams: function() {
      let params = {
        q: this.search,
        maxResults: this.paginationCount,
        startIndex: ( this.paged > 0 ) ? ( this.paginationCount * this.paged ) + 1 : 0,
      }

      // console.log( 'PARAMS', params)
      return params
    },

    cancelSearch: function() {
      if (this.cancelSource) {
        this.cancelSource.cancel()
      }
    },

    searchPosts: function() {
      this.loading = true
      this.cancelSearch()
      this.cancelSource = axios.CancelToken.source()
      axios({
        url: this.searchUrl + 'Search.json',
        method: 'get',
        params: this.getSearchParams(),
        cancelToken: this.cancelSource.token,
        // headers: {'X-WP-Nonce': this._nonce}
      }).then((response) => {
        this.searchId       = response.data.SearchId
        this.searchResponse = response
        this.documentOffset = response.data.Offset
        this.documents      = response.data.Documents
        this.SearchString   = response.data.Decorations.Search.SearchString
        this.TotalResults   = response.data.TotalResults
        this.banner         = response.data.Decorations.Banners
        this.loading        = false
        this.cancelSource   = null

      })
      .catch((response) => {
        console.log( 'SEARCH ERROR', response)
      })
    },

    typeAhead: function(input) {
      const url = `${this.searchUrl}TypeAhead.json?q=${encodeURI(input)}`

      return new Promise(resolve => {
        if (input.length < 3) {
          return resolve([])
        }

        fetch(url)
          .then(response => response.json())
          .then(data => {
            resolve(data)
          })
      })
    },

    getTypeAheadResult: function(result) {
      if ( result.AverageNumberOfResults == 0 ) {
        return result.Term;
      }

      return result.Term + ' (' + result.AverageNumberOfResults + ')';
    },

    handleTypeAheadSubmit(result) {
      if ( typeof result == 'undefined' ) {
        this.doSearch();
        return;
      }
      this.search = result.Term;
      this.doSearch();
      return;
    },

    getObjField(obj, key) {
      return _get(obj, key, false)
    },

    getObjFieldValue(properties, key, showMarkup = true) {
      let result = 'undefined';
      let markup = ( showMarkup ) ? 'ValueMarkup' : 'Value'
      if ( showMarkup ) {
        result = _find(properties, {Name:key})
      } else {
        result = _find(properties, {Name:key})
      }

      return ( typeof result !== 'undefined' ) ? result[markup] : ''
    },

    getLinkUrl(document) {
      let url = this.searchUrl;
      let redirect = 'Redir'
      let paramsObj = {
        url: this.getObjFieldValue(document.Properties, 'Uri'),
        searchId: this.searchId,
        documentId: document.Id,
        documentOffset: this.documentOffset,
      }
      let queryString = this.buildQueryStringFromObj(paramsObj);

      return this.getObjFieldValue(document.Properties, 'Uri');
    },

    getTitle(document) {
      // - Fagbevægelsens Hovedorganisation
      let title = this.getObjFieldValue(document.Properties, 'Title', false);
      return title.replace(" - Fagbevægelsens Hovedorganisation", '');
    },

    getDateTime(document) {
      let date = this.getObjFieldValue(document.Properties, 'PublishedDate', false);
      return date
    },

    getFormattedDate(document) {
      let date = this.getDateTime(document)

      return moment(String(date)).format('D MMMM Y')
    },

    getContentType(document) {
      let type = this.getObjFieldValue(document.Properties, 'ContentType', false);
      return ( type != '' ) ? type : false;
    },

    getContentTypeURL(document) {
      let typeUrl = this.getObjFieldValue(document.Properties, 'ContentTypeUrl', false);
      return ( typeUrl != '' ) ? typeUrl : false;
    },

    getContentPrimaryCategory(document) {
      let category = this.getObjFieldValue(document.Properties, 'ContentPrimaryCategory', false);
      if ( category == 'Uncategorized' ) {
        category = '';
      }
      if ( category == 'Fagligt.eu' ) {
        category = 'EU';
      }
      return ( category != '' ) ? category : false;
    },

    getContentPrimaryCategoryURL(document) {
      let categoryUrl = this.getObjFieldValue(document.Properties, 'ContentPrimaryCategoryUrl', false);
      return ( categoryUrl != '' ) ? categoryUrl : false;
    },

    trumpet( document ) {
      let str = this.getTitle(document);
      let res = str.split(":");
      return ( str.indexOf(':') !== -1 ) ? '<span class="highlighted_title">' + res[0] + ':</span> ' + res[1] : str;
    },

    getAnkiroUrl(document, url = '') {
      let searchUrl = this.searchUrl;
      let redirect = 'Redir'
      let paramsObj = {
        url: ( url == '' ) ? this.getObjFieldValue(document.Properties, 'Uri') : url,
        searchId: this.searchId,
        documentId: document.Id,
        documentOffset: this.documentOffset,
      }
      let queryString = this.buildQueryStringFromObj(paramsObj);

      return `${searchUrl}${redirect}?${queryString}`;
    },

    pingAnkiro(e) {
      // e.preventDefault();
      let url = e.currentTarget.src;
      let ankiroUrl = e.currentTarget.getAttribute('data-ankiro');

      fetch(ankiroUrl)
        .then(response => response.json())
        .then(data => {
          console.log( 'DATA', data )
        })
        .catch((response) => {
          console.log( 'ERROR', response )
        })
    },

    buildQueryStringFromObj(obj) {
      return _map(obj,function(v,k){
        return encodeURIComponent(k) + '=' + encodeURIComponent(v);
      }).join('&');
    },

    // The callback function which is triggered when the user hits on an item
    // (required)
    onHit (item) {
      // alert(item)
      // console.log('TA ITEM', item);
    },

    // The callback function which is triggered when the response data are received
    // (optional)
    prepareResponseData (data) {
      // data = ...
      // console.log( 'TA DATA', data );
      return data
    }

  },

}